import script from "./Sign.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sign.vue?vue&type=script&setup=true&lang=ts"

import "./Sign.vue?vue&type=style&index=0&id=d2869502&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2869502"]])

export default __exports__